import React, {useEffect} from "react";
import {StatusBar, Text, TouchableWithoutFeedback, View} from 'react-native';
import {useSelector} from "react-redux";
import {
    getBookModalVisibility,
    getCheckingForUpdates,
    getConfig,
    getConnectionStatus,
    getCurrentState,
    getSocketUrl, getSoketiUrl,
} from "./src/reducers/configSlice";
import {STATE_ACTIVATE, STATE_HOME, STATE_WAITING} from "./src/constants/default";
import Notification from "./src/components/Notification";
import Loader from "./src/components/Loader";
import HiddenLongPress from "./src/components/HiddenLongPress";
import {isConnected, reconnectSocket} from "./src/services/socket/socket";
import {EventBus} from "./src/services/EventBus";
import {checkAndApplyUpdates} from "./src/services/expoUpdates";
import ScreenComponent from "./src/components/ScreenComponent";
import useConditionalInterval from "./src/services/hooks/useConditionalInterval";
import { DISPLAY_VERSION } from "./src/constants/versionConstants";
import useLanguageUpdate from "./src/services/hooks/useLanguageUpdate";

import {actuatedNormalize} from "./src/services/helpers/stylingHelpers";
import {FONT_SIZE_XS} from "./src/constants/styleConstants";
import {WebToastContainer} from "./src/services/toastMessage";
import {reconnectSoketi} from "./src/services/soketi";
import {STORAGE} from "./src/services/storage";

const Wrapper = ({backgroundColor}) => {
    const connectionStatus = useSelector(getConnectionStatus)
    const config = useSelector(getConfig)
    const screen = useSelector(getCurrentState)
    const bookModalVisible = useSelector(getBookModalVisibility)
    const socketUrl = useSelector(getSocketUrl)
    const soketiUrl = useSelector(getSoketiUrl)
    const checkingForUpdates = useSelector(getCheckingForUpdates)

    const shouldReconnect = () => {
        return (socketUrl || soketiUrl) && (!connectionStatus || ![STATE_ACTIVATE, STATE_HOME, STATE_WAITING].includes(screen));
    };

    useConditionalInterval(async () => {
        const soketiUrl = await STORAGE.get("soketiUrl");
        if (soketiUrl) {
            await reconnectSoketi();
        } else {
            await reconnectSocket()
        }
    }, Math.floor(Math.random() * 120000) + 30000, shouldReconnect);

    useLanguageUpdate(config);

    return (
        <View style={styles.container}>
            {
                !checkingForUpdates ?
                    <View style={[styles.container, {backgroundColor: backgroundColor}]}>
                        <StatusBar hidden={true} backgroundColor={'transparent'} translucent/>
                        <ScreenComponent screen={screen} />
                        {!bookModalVisible && <Notification/>}
                        {!bookModalVisible && <Loader/>}
                    </View> :
                    <Text style={{alignSelf: 'center', marginTop: 'auto', marginBottom: 'auto', color: 'white', fontSize: actuatedNormalize(20)}}>
                        {translate('Checking for updates')}...
                    </Text>
            }
            <HiddenLongPress onEvent={() => {EventBus.emit('destroyInstance');}} position={'topRight'} duration={15000}/>
            <TouchableWithoutFeedback onPress={ async () => await checkAndApplyUpdates()}>
                <Text style={{position: 'absolute', right: 10, bottom: 5, color: 'lightgrey', fontSize: FONT_SIZE_XS}}>
                    {DISPLAY_VERSION}
                </Text>
            </TouchableWithoutFeedback>
            <WebToastContainer />
        </View>
    );
}

const styles = {
    container: {
        flex: 1,
    }
};

export default Wrapper